export default () => ({
  canInteract: true,
  isBooting: true,
  language: 'en',
  step: 1,
});
